module.exports = __webpack_public_path__ + "static/img/areaB_01.ea4cb99.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_01.png
// module id = 1262
// module chunks = 1